import EngineModule from '../../../EngineModule';
import {
	NS as PlannerQuestionsNS
}                   from '../../../components/customers/standing/StandingQuestions/StandingQuestions';

export default () => new EngineModule.UIEngineModule({
	type :             'ui',
	id :               'standing-questions',
	dependencies :     [
		'oms-basket',
		'viewer-planner'
	],
	modulesBefore :    [
		'product-editor',
		'viewer-planner-layout-editor',
		'viewer-planner-dimensionsEditor',
		'viewer-planner-floor-editor',
		'viewer-planner-walls-editor',
		'viewer-planner-furniture-editor',
		'standing-highSign'
	],
	modulesAfter :     [],
	allowedCustomers : [ /* Local MPA */'XUJG0A2TF5', /* Prod */'STAODAZNIS', 'sam1_12345' ],
	usableCondition :  {
		type : 'and',
		LHS :  {
			type :      'notequal',
			component : 'K.basket',
			property :  'TARGET.basket.currentProduct',
			value :     null
		},
		RHS :  {
			type :      'notequal',
			component : 'K.basket',
			property :  '[*]TARGET.basket.currentProduct.getPart(["layout"]).currentOption',
			value :     null
		}
	},
	displayCondition : null,
	generateComponentConfiguration() : PlannerQuestionsNS.Configuration {
		return {};
	},
	async initialize() {
	}
});
